<script lang="ts">
  import { defineComponent } from "vue";
  import FicheVirementSalarie from '@/generated/fiches/FicheVirementSalarie.vue';
  export default defineComponent({
    extends: FicheVirementSalarie,
    components: {}
})
</script>
